import { faker } from '@faker-js/faker';

import type { ChangeRetirementDateGetResponse } from '../types/ChangeRetirementDateGetResponse';

export function createChangeRetirementDateGetResponse(
  data: NonNullable<Partial<ChangeRetirementDateGetResponse>> = {}
): NonNullable<ChangeRetirementDateGetResponse> {
  return {
    ...{
      data: { retirement_age: faker.number.int() },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
